(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desear-seasonal-popup"] && !Shopify.designMode) return;
  try {
    
function initDesearSeasonal(scope = document) {
  scope.querySelectorAll('.ds-season-dialog:not([data-initialized])').forEach(dialog => {
    dialog.dataset.initialized = 'true';
    let attempts = 0;
    const showWhenClear = () => {
      if (!dialog.isConnected || document.hidden) return;
      const visibleOverlay = document.querySelector('dialog[open], #shopify-pc__banner:not([style*="display: none"])');
      if (visibleOverlay && visibleOverlay.getBoundingClientRect().height > 0) {
        if (++attempts < 12) window.setTimeout(showWhenClear, 2000);
        return;
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
    };
    window.setTimeout(showWhenClear, window.Shopify?.designMode ? 500 : (Number(dialog.dataset.delay) || 10000));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
  });
}
initDesearSeasonal();
document.addEventListener('shopify:section:load', event => initDesearSeasonal(event.target));
document.addEventListener('shopify:section:select', event => {
  const dialog = event.target.querySelector('.ds-season-dialog');
  if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
